export const SERIES = {
    258503: "My Best Friends",
    258495: "Shimmer Paws",
    258520: "Yummy",
    258521: "Super Girl",
    258522: "Little Unicorn",
    267819: "Let's be Mermaids",
    267820: "Shimmer Wings",
};
